import { gql } from '@apollo/client';

export const PLAYERMATCHES = gql`
  query matchUps($personFilter: [PersonFilterOptions], $filter: MatchUpFilterOptions) {
    matchUps(personFilter: $personFilter, filter: $filter) {
      totalItems
      items {
        score {
          scoreString
          sets {
            winnerGamesWon
            loserGamesWon
            winRatio
            tiebreaker {
              winnerPointsWon
              loserPointsWon
            }
          }
          superTiebreak {
            winnerPointsWon
            loserPointsWon
          }
        }
        sides {
          sideNumber
          players {
            person {
              personID
              nativeFamilyName
              nativeGivenName
            }
          }
          extensions {
            name
            value
          }
        }
        winningSide
        start
        end
        type
        matchUpFormat
        status
        tournament {
          providerTournamentId
          subCategory
        }
        extensions {
          name
          value
        }
        roundName
        collectionPosition
      }
    }
  }
`;
